import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { BaseRequest } from '../models'
import { AIAgentModel } from '../../models/AIAgentModel'

const _BASE_URL = import.meta.env.REACT_APP_AI_BASE_URL!

interface GetAIAgentModelRequest extends BaseRequest {
  aiAgentId: string
}

export const aiAgentModelApi = createApi({
  reducerPath: 'aiAgentModelApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getAiAgent: builder.query<AIAgentModel, GetAIAgentModelRequest>({
      query: ({ accountId, aiAgentId }) => ({
        url: `/accounts/${accountId}/ai-agents/${aiAgentId}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: AIAgentModel }) => response.data,
    }),
  }),
})

export const { useLazyGetAiAgentQuery } = aiAgentModelApi
